import { createFileRoute } from "@tanstack/react-router";
import { ManageTermsRoute } from "src/containers/manageTermsRoute";

export const Route = createFileRoute("/_layout-nosidebar/manageTerms")({
    component: ManageTermsPage,
});

export default function ManageTermsPage() {
    return <ManageTermsRoute />;
}
